import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { RESUBSCRIBE_API_PREFIX } from '../api/unsubscribe-api'

export const useResubscribe = () => {
  const { fetcher, isFetching } = useApiWrapperWithErrorValidation({
    method: RequestMethodsEnum.post,
  })
  return {
    resubscribeToMarketingEmails: async (slug: string, messageId: string) => {
      try {
        await fetcher(`${RESUBSCRIBE_API_PREFIX}/resubscribe-page/${slug}/${messageId}`)
      } catch (e) {
        throw e
      }
    },

    resubscribeToAutomationRule: async (recipientEmailAddress: string, id: string) => {
      try {
        await fetcher(
          `${RESUBSCRIBE_API_PREFIX}/resubscribe-to-automation-rule/${recipientEmailAddress}/${id}`,
        )
      } catch (e) {
        throw e
      }
    },

    resubscribeToMarketingEmailsCampaign: async (
      slug: string,
      messageId: string,
      campaignId: string,
    ) => {
      try {
        await fetcher(
          `${RESUBSCRIBE_API_PREFIX}/resubscribe-page/${slug}/${messageId}/campaign/${campaignId}`,
        )
      } catch (e) {
        throw e
      }
    },

    resubscribeToTransactionalEmail: async (slug: string) => {
      try {
        await fetcher(`${RESUBSCRIBE_API_PREFIX}/resubscribe-to-transactional-emails/${slug}`)
      } catch (e) {
        throw e
      }
    },

    isFetching: isFetching,
  }
}
